<template>
    <form class="modal_content" @submit.prevent="store()">
        <p><strong>{{ $t('package') }}: </strong>{{ packageName }}</p>
        <form @submit.prevent="store()" v-if="showForm">
            <div class="modal_content p-0 p-b-20">
                <div class="row">
                    <div class="col-sm-6 col-md-8 m_bottom_15" :class="{'has-error': errors['supplier_id']}">
                        <label class="control-label">{{ $t('supplier') }}</label>
                        <pml-select v-model="record.supplier_id" :options="suppliers" label="fancy_name"></pml-select>
                        <span class="error" v-if="errors['supplier_id']">{{ errors['supplier_id'][0] }}</span>
                    </div>
                    <div class="col-sm-6 col-md-4 m-t-30">
                        <pml-switch v-model="record.show_details" :text="$t('show_details')" class="switch_text_left"></pml-switch>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 col-md-6 m_sm_bottom_15" :class="{'has-error': errors['supplier_product_id']}">
                        <label class="control-label">{{ $t('product') }}</label>
                        <div class="custom_select">
                            <vue-multiselect v-model="record.supplier_product" :placeholder="$t('select_an_option')" :allow-empty="true" :options="products" :searchable="true" :loading="loadingProducts" :customLabel="customLabel" selectLabel="" selectedLabel="" deselectLabel="" :disabled="!record.supplier_id"></vue-multiselect>
                        </div>
                        <span class="error" v-if="errors['supplier_product_id']">{{ errors['supplier_product_id'][0] }}</span>
                    </div>
                    <div class="col-sm-6 col-md-3" :class="{'has-error': errors['amount']}">
                        <label class="control-label">{{ $t('amount') }}</label>
                        <input type="text" class="form-control" v-model.lazy="record.amount" v-pml-mask="'number'">
                        <span class="error" v-if="errors['amount']">{{ errors['amount'][0] }}</span>
                    </div>
                    <div class="col-md-3 t_right m-t-23">
                        <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                        <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row" v-if="!showForm">
            <div class="col-md-6 p-b-10 m_md_bottom_15">
                <span class="btn btn-warning" v-pml-tooltip="$t('refresh')" @click.prevent="fetchRecord()"><i class="fa fa-refresh"></i></span>
                <router-link :to="{ name: 'packages.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <span class="btn btn-default" @click.prevent="showForm = true"><i class="fa fa-plus-circle"></i> {{ $t('product') }} </span>
            </div>
        </div>
        <div class="over_auto" v-pml-block="isLoading">
            <table class="table table-striped table-bordered m-0 table_border_out">
                <thead>
                    <tr>
                        <th>{{ $t('product') }}</th>
                        <th class="t_center">{{ $t('amount') }}</th>
                        <th class="t_center">{{ $t('unit_price') }}</th>
                        <th class="t_center">{{ $t('total') }}</th>
                        <th class="t_center w_100">{{ $t('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list" :key="item.id">
                        <td>
                            {{ item.supplier_product.product.name }} <small v-if="item.supplier_product.annotations">({{ item.supplier_product.annotations }})</small>
                            <small class="show">
                                {{ item.supplier_product.supplier.name }}
                                <i class="fa fa-eye" v-if="item.show_details"></i>
                                <i class="fa fa-file" v-if="item.show_attachments"></i>
                            </small>
                        </td>
                        <td class="t_center">{{ item.amount }} {{ $t(item.supplier_product.unit) }}</td>
                        <td class="t_center">
                            {{ item.supplier_product.price | pmlFormatCurrencyById(item.supplier_product.supplier.currency_id) }}
                        </td>
                        <td class="t_center">
                            {{ item.amount * item.supplier_product.price | pmlFormatCurrencyById(item.supplier_product.supplier.currency_id) }}
                        </td>
                        <td class="t_center">
                            <span class="btn btn-xs btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="destroy(item.id)"><i class="fa fa-times"></i></span>
                        </td>
                    </tr>
                    <tr v-if="!list.length">
                        <td class="t_center" colspan="5"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getPackageProducts, storeProduct, destroyProduct } from 'services/packages'
    import { getProducts } from 'services/suppliers'
    import { mapGetters, mapActions } from 'vuex'
    import { isEmpty, isNil } from 'lodash'

    export default {
        name: 'PackageProducts',
        data () {
            return {
                showForm: false,
                isLoading: false,
                loadingProducts: false,
                isSaving: false,
                package: {},
                record: {
                    supplier_id: null,
                    supplier_product: null
                },
                products: [],
                errors: []
            }
        },
        mounted () {
            this.fetchRecord()
        },
        watch: {
            'record.supplier_id' (val) {
                if (isNil(val)) {
                    this.products = []
                    this.record.supplier_product = null
                } else {
                    this.loadProducts(val)
                }
            },
            '$route' () {
                this.fetchRecord()
            }
        },
        computed: {
            ...mapGetters({
                packages: 'getPackages',
                suppliers: 'getSuppliers',
                tenant: 'getTenant'
            }),
            packageName () {
                return this.package.name || ''
            },
            list () {
                return this.package.products || []
            }
        },
        methods: {
            ...mapActions([ 'packageProductsAmountUpdate' ]),
            fetchRecord () {
                this.isLoading = true

                getPackageProducts(this.$route.params.id)
                    .then(response => {
                        this.package = response.data
                        this.packageProductsAmountUpdate(response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            customLabel ({product, annotations}) {
                let notes = isEmpty(annotations) ? '' : ` - ${annotations}`
                return product.name + notes
            },
            loadProducts (supplierId) {
                this.loadingProducts = true

                getProducts(supplierId)
                    .then(response => { this.products = response.data.products })
                    .catch(() => Notify.success(trans('_notifications.error')))
                    .then(() => { this.loadingProducts = false })
            },
            cancel () {
                this.showForm = false
                this.record = {
                    supplier_id: null,
                    supplier_product: null
                }
                this.errors = []
                this.products = []
            },
            store () {
                this.isSaving = true

                this.record.supplier_product_id = this.record.supplier_product.id

                storeProduct(this.$route.params.id, this.record)
                    .then(response => {
                        this.packageProductsAmountUpdate(response.data)
                        this.package = response.data
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isSaving = false })
            },
            destroy (id) {
                destroyProduct(this.$route.params.id, id)
                    .then(response => {
                        this.packageProductsAmountUpdate(response.data)
                        this.package = response.data
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/packages/components/products/Main.vue